import { render, staticRenderFns } from "./bottomCenter.vue?vue&type=template&id=b8e372cc&scoped=true&"
import script from "./bottomCenter.vue?vue&type=script&lang=js&"
export * from "./bottomCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e372cc",
  null
  
)

export default component.exports